// extracted by mini-css-extract-plugin
export default {"menuButton":"Dot3Menu_menuButton__dyA+U"};